
import { PopUpCodes } from "../../../common/enum/PopUpCodes";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { resetRequestIntegrationForm } from "../../../redux/reducers/request/requestIntegrations/form";
import { PopUpForm } from "../../common/popup/popUpForm/popUpForm";
import { IntegrationRequestForm } from "./form/form";

export const IntegrationRequestController = () => {
    const { showPopUp } = useAppSelector((state) => state.requestIntegrationForm);

    const dispatch = useAppDispatch();
    
    const onCancel = () => {
        dispatch(resetRequestIntegrationForm());
    };

    const onSave = () => {
        onCancel();
    };

    return (
        <PopUpForm
            content={<IntegrationRequestForm />}
            title={""}
            isVisible={showPopUp === PopUpCodes.CREATE}
            onCancel={onCancel}
            onSave={onSave}
            width={"80vw"}
            onlyHidden={true}
            height={"calc(80vh - 10rem)"}
        />
    );
};
